import React, { Component, Fragment } from "react";
import {
    rejectApplicant,
    approveApplicant
} from "../../../services/employerJobListing";
import AppContext from "../../../contexts/AppContext";
import NoData from "../../utilities/NoData";
import LoadingData from "../../utilities/LoadingData";
import RejectModal from "./RejectModal";
import ApprovedModal from "./ApprovedModal";
import { records } from "../../../services/employerApplicant";
import {create } from "../../../services/message";

export class ApplicantModal extends Component {
    state = {
        items: [],
        meta: {},
        loading: true,
        showApproveModal: false,
        showRejectModal: false,
        id: 0
    };

    toggleApproveModal = id => {
        this.setState({
            id: id,
            showApproveModal: !this.state.showApproveModal
        });
    };
    toggleRejectModal = id => {
        this.setState({ id: id, showRejectModal: !this.state.showRejectModal });
    };

    rejectApplicant = () => {
        return rejectApplicant(this.state.id).then(response => {
            records(this.props.item.id)
                .then(response => {
                    this.setState({
                        showApproveModal: false,
                        showRejectModal: false,
                        items: response.data,
                        meta: response.meta,
                        loading: false
                    });
                })
                .catch(error => {
                    this.context.state.handelError(error);
                });
        });
    };

    approveApplicant = () => {
        return approveApplicant(this.state.id).then(response => {
            records(this.props.item.id, 1)
                .then(response => {
                    this.setState({
                        showApproveModal: false,
                        showRejectModal: false,
                        items: response.data,
                        meta: response.meta,
                        loading: false
                    });
                })
                .catch(error => {
                    this.context.state.handelError(error);
                });
        });
    };

    createMessage = (userid , jobId) =>{
        create(userid , jobId )
        .then(response => {
             this.props.history.push(
                "/" + this.context.state.user.type + "/messages/" + response.data.key
            );
        })

    }
    componentDidMount() {
        records(this.props.item.id, 1)
            .then(response => {
                this.setState({
                    items: response.data,
                    meta: response.meta,
                    loading: false
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    }

    render() {
        return (
            <Fragment>
                <div className="model-container model-center model-backdrop-show ">
                    <div
                        aria-labelledby="model-title"
                        aria-describedby="model-content"
                        className="model-popup model-modal model-show applicants"
                        role="dialog"
                        aria-live="assertive"
                        aria-modal="true"
                    >
                        <h2 className="model-title text-left" id="model-title">
                            Job Applicants
                        </h2>
                        <div className="model-content">
                            <div className="table-responsive">
                                <table className="table table-sm table-nowrap card-table">
                                    <tbody className="list">
                                        {this.state.loading === true ? (
                                            <LoadingData></LoadingData>
                                        ) : this.state.items.length >= 1 ? (
                                            <Fragment>
                                                {this.state.items.map(
                                                    (item, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>
                                                                    <div className="row align-items-center">
                                                                        <div className="col-auto">
                                                                            <a href="">
                                                                                <img
                                                                                    src={
                                                                                        item
                                                                                            .user
                                                                                            .image
                                                                                    }
                                                                                    className="cc-image-lg rounded-circle"
                                                                                    alt={`${item.user.first_name} ${item.user.last_name}`}
                                                                                />
                                                                            </a>
                                                                        </div>
                                                                        <div className="col ml-n2">
                                                                            <h4 className="mb-1 name">
                                                                                {
                                                                                    item
                                                                                        .user
                                                                                        .first_name
                                                                                }{" "}
                                                                                {
                                                                                    item
                                                                                        .user
                                                                                        .last_name
                                                                                }
                                                                            </h4>
                                                                            <p className="small mb-0">
                                                                                {
                                                                                    item
                                                                                        .user
                                                                                        .email
                                                                                }
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <time
                                                                        dateTime={
                                                                            item.created_at
                                                                        }
                                                                    >
                                                                        {
                                                                            item.created_at
                                                                        }
                                                                    </time>
                                                                </td>
                                                                <td className="text-right">
                                                                    {item.state ===
                                                                    "applied" ? (
                                                                        <Fragment>
                                                                            <button
                                                                                onClick={e =>
                                                                                    this.toggleApproveModal(
                                                                                        item.id
                                                                                    )
                                                                                }
                                                                                type="button"
                                                                                className="btn btn-success btn-sm"
                                                                            >
                                                                                Approve
                                                                            </button>
                                                                            <button
                                                                                type="button"
                                                                                onClick={e =>
                                                                                    this.toggleRejectModal(
                                                                                        item.id
                                                                                    )
                                                                                }
                                                                                className="btn btn-danger btn-sm  ml-2"
                                                                            >
                                                                                Reject
                                                                            </button>
                                                                        </Fragment>
                                                                    ) : (
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-default btn-sm ml-2"
                                                                        >
                                                                            {
                                                                                item.state
                                                                            }
                                                                        </button>
                                                                    )}
                                                                    {
                                                                                    item
                                                                                        .user
                                                                                        .plan_id === 1 ? null : 
                                                                                        <button
                                                                                            onClick={e =>
                                                                                                this.createMessage(
                                                                                                    item.user.id ,
                                                                                                    item.job.id
                                                                                                )
                                                                                            }
                                                                                            type="button"
                                                                                            className="btn btn-info btn-sm ml-2"
                                                                                        >
                                                                                            Message
                                                                                        </button>
                                                                                }
                                                                    
                                                                </td>
                                                            </tr>
                                                        );
                                                    }
                                                )}
                                            </Fragment>
                                        ) : (
                                            <NoData></NoData>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="model-actions justify-content-start">
                            <button
                                type="button"
                                className="btn btn-default ml-3 mt-4"
                                onClick={this.props.toggleApplicantModal}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
                {this.state.showApproveModal ? (
                    <ApprovedModal
                        approveApplicant={this.approveApplicant}
                        toggleApproveModal={this.toggleApproveModal}
                        item={this.props.item}
                    ></ApprovedModal>
                ) : null}

                {this.state.showRejectModal ? (
                    <RejectModal
                        toggleRejectModal={this.toggleRejectModal}
                        rejectApplicant={this.rejectApplicant}
                        item={this.props.item}
                    ></RejectModal>
                ) : null}
            </Fragment>
        );
    }
}

ApplicantModal.contextType = AppContext;
export default ApplicantModal;



// WEBPACK FOOTER //
// ./src/components/employer/jobListing/ApplicantModal.js